<div class="pa-item-list pa-multi-selection">
    <div (click)="message.data.responseItemData.selectionInactive === undefined && selectItem(item)" *ngFor="let item of message.data.responseItemData.selectionItems" [class.active]="item.selected === true"
         [class.disable]="message.data.responseItemData.selectionInactive === true"
         [ngClass]="item.cssClasses"
         class="pa-list-item">
        <div [style.background-image]="'url(' + item.imageUrl + ')'"
             class="pa-item-image">
            <div *ngIf="item.selected" class="pa-multi-selection-icon">
            </div>
        </div>
        <div class="pa-item-content">
            <h2 [title]="item.title">{{item.title}}</h2>
        </div>
    </div>
</div>
<button (click)="sendSelectItems(message.data.responseItemData.selectionItems)" *ngIf="message.data.responseItemData.hideSelectionButton === undefined" class="pa-multi-button"
        id="multibutton">Auswahl bestätigen
</button>


